import Vue from "vue";
import App from "./App.vue";
import VueTippy from "vue-tippy";

export default function init() {
  const element = document.getElementById("shopLogin");

  if (element) {
    Vue.use(VueTippy);
    Vue.config.productionTip = false;

    new Vue({
      render: createElement => {
        const context = {
          props: { ...element.dataset }
        };
        return createElement(App, context);
      }
    }).$mount("#shopLogin");
  }
}
